export default [
    // *===============================================---*
    // *--------- Warehouse  ---- ---------------------------------------*
    // *===============================================---*
    {
        path: '/warehouse/warehouse-list',
        name: 'warehouse-list',
        component: () => import('@/views/inventory/warehouse/ClientsList.vue'),
        meta: {
            pageTitle: 'Warehouses List',
            breadcrumb: [
                {
                    text: 'Warehouses List',
                    active: true,
                },
            ],
            permission: 'Permissions.Inventory.View'  
        },
    },
    {
        path: '/warehouse/warehouse-view/:id',
        name: 'warehouse-view',
        component: () => import('@/views/inventory/warehouse/View.vue'),
        meta: {
            pageTitle: 'View Warehouse',
            breadcrumb: [
                {
                    text: 'Warehouses List',
                    to: '/warehouse/warehouse-list',
                },
                {
                    text: 'View Warehouse',
                    active: true,
                },
            ],
            permission: 'Permissions.Inventory.View'  
        },
        props: true
    },
]